import React from "react";
import { useFormContext } from "react-hook-form";
import { FieldErrorMessage } from "../ui/Text";
import { Validation } from "@/types/form";
import { Button } from "@/components/ui/button";
import GoogleAddress from "./modal/GoogleAddress";
import { ModalConfig, withModal } from "@/provider/withModalProvider";

interface AddressInputProps {
  readonly rows?: number;
  readonly columns?: number;
  field: string;
  label: string;
  placeholder: string;
  disabled?: boolean;
  validation: Validation;
  defaultValue?: string;
  openModal: (modalKey: string, props?: any) => void;
}

const modalConfig: ModalConfig = {
  googleAddress: {
    component: GoogleAddress,
    title: "Choose on Map",
    modalClassName: "max-h-[calc(100vh-50px)] overflow-y-auto !max-w-1/2 md:min-w-[650px]",
  },
};

const AddressInput: React.FC<AddressInputProps> = ({ openModal, label, rows = 2, columns = 10, placeholder, field, disabled, validation, defaultValue }) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const errorMessage: any = errors[field]?.message;

  const getRegisterOptions = () => {
    const registerOptions: any = {};

    if (validation.required) {
      registerOptions.required = "This field is required.";
    }

    if (validation?.minLength) {
      registerOptions.minLength = {
        value: validation.minLength,
        message: `The minimum character allowed is ${validation.minLength}`,
      };
    }
    if (validation?.maxLength) {
      registerOptions.maxLength = {
        value: validation.maxLength,
        message: `The maximum character allowed is ${validation.maxLength}`,
      };
    }
    return registerOptions;
  };

  const handleChooseOnMap = () => {
    openModal("googleAddress", { parentSetValue: setValue, parentGetValues: getValues });
  };

  return (
    <div className="mt-1 relative">
      <div className="absolute -top-8 right-0">
        <Button
          type="button"
          variant="link"
          className="!text-13 text-text-primary !p-1"
          onClick={(e) => {
            e.preventDefault();
            handleChooseOnMap();
          }}
        >
          Choose on map
        </Button>
      </div>
      <textarea
        id={label + "_text"}
        rows={rows}
        cols={columns}
        className={`flex w-full px-3 py-7 resize-none text-13 border text-text-default border-[#1211271F] rounded-lg
                  border-fieldBorder placeholder:text-neutral-400 
                  disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none
                  focus:border-text-primary-500 ${disabled ? "opacity-75" : ""}`}
        placeholder={placeholder}
        {...register(field, {
          ...getRegisterOptions(),
        })}
        disabled={disabled}
        defaultValue={defaultValue}
      />
      {errorMessage && <FieldErrorMessage text={errorMessage} />}
    </div>
  );
};

export const AddressInputWithModal = withModal(AddressInput, modalConfig);
